module.exports = __webpack_public_path__ + "img/app1.d7ba752a.png";